// Панель для отображения результатов расчёта

import type { ReactNode } from 'react';
import './Results.css';

interface ResultRow {
  label: string;
  value: string | number;
  unit?: string;
  highlight?: 'success' | 'danger' | 'warning';
}

interface ResultPanelProps {
  title: string;
  status?: ReactNode;
  rows: ResultRow[];
  className?: string;
}

export function ResultPanel({ title, status, rows, className = '' }: ResultPanelProps) {
  return (
    <div className={`result-panel ${className}`}>
      <div className="result-panel__header">
        <h3 className="result-panel__title">{title}</h3>
        {status && <div className="result-panel__status">{status}</div>}
      </div>
      <div className="result-panel__body">
        {rows.map((row, index) => (
          <div key={index} className="result-panel__row">
            <span className="result-panel__label">{row.label}</span>
            <span className={`result-panel__value ${row.highlight ? `result-panel__value--${row.highlight}` : ''}`}>
              {row.value}
              {row.unit && <span className="result-panel__unit"> {row.unit}</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
